(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cart"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    // Initialize Slick Slider
    $('.cart-slider-box').slick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-dashboard"] && !window.DesignMode) return;
  try {
    
  /* =============
    dashboard left sidebar
    =====================*/
    document.querySelector('.left-dashboard-show').addEventListener('click', function() {
        document.querySelector('.dashboard-left-sidebar').classList.add('open');
    });

    document.querySelector('.dashboard-left-sidebar-close').addEventListener('click', function() {
        document.querySelector('.dashboard-left-sidebar').classList.remove('open');
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !window.DesignMode) return;
  try {
    
   $(document).ready(function(){
      // Initialize Slick Slider
      $('.searchSlider').slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
              {
                  breakpoint: 1200,
                  settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1
                  }
              },
              {
                  breakpoint: 576,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                  }
              }
          ]
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-instagram-layout-1"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
      $('.insta-slider').slick({});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-latest-blog"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
    $('.latest-blog-slider').slick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-lookbook"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.lookbook-slider').slick();

      $('.lookbook-dot').on('click', function () {
    const slideIndex = $(this).data('slide') - 1; 
    $('.lookbook-slider').slick('slickGoTo', slideIndex);
  });

    $('.lookbook-slider').on('afterChange', function (event, slick, currentSlide) {
      $('.lookbook-dot').removeClass('active'); 
      $(`.lookbook-dot[data-slide=${currentSlide + 1}]`).addClass('active'); 
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-offer-slider"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
    $('.offer-slider').slick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-team-member"] && !window.DesignMode) return;
  try {
    
      $(document).ready(function(){
      $('.team-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonial"] && !window.DesignMode) return;
  try {
    
      $(document).ready(function(){
      $('.testimonial-slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-topbrand-section"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
    $('.brandSlider').slick()
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_all_collection"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
    $('.All-Collection-Slider').slick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_banner-1"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
    $('.bannerCarousel').slick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_banner-2"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
    $('.banner-slick-slider').slick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_banner-3"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
    $('.banner-slick-2-slider').slick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_banner-5"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
    $('.bannerCarousel').slick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_collection_banner-1"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
      $('.special-offer-slickSlider').slick();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_product_slider"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
    $('.fashikart-slide').slick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_top_category"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
    $('.top-categories-slide').slick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
      $(document).ready(function () {
      $('.collection-images-slide').slick();

      function checkImagesLoaded() {
        var images = $('.fashion-box img');
        var loadedCount = 0;

        images.each(function () {
          if (this.complete) {
            loadedCount++;
          } else {
            $(this).on('load', function () {
              loadedCount++;
              if (loadedCount === images.length) {
                handleContentLoading();
              }
            });
          }
        });

        if (loadedCount === images.length) {
          handleContentLoading();
        }
      }

      function handleContentLoading() {
        setTimeout(function () {
          showActualContent();
        }, 5000);
      }

      function showActualContent() {
        $('.section-wrapper').addClass('loaded');
      }

      checkImagesLoaded();
    });
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('label.facet-checkbox').forEach(label => {
      label.addEventListener('click', () => {
        const checkboxId = label.getAttribute('for');
        if (checkboxId) {
          const checkbox = document.getElementById(checkboxId);
          if (checkbox && !checkbox.disabled) {
            checkbox.checked = !checkbox.checked;
            label.classList.toggle('active', checkbox.checked);
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  $(document).ready(function () {
  $(".slider-bottom-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    loop: true,
    infinite: false,
    fade: true,
    asNavFor: ".slider-bottom-nav",
  });
  $(".slider-bottom-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".slider-bottom-for",
    focusOnSelect: true,
    loop: true,
    infinite: false,
    draggable: true,
    swipeToSlide: true,
    responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 0,
      settings: {
        slidesToShow: 1
      }
    }
  ]
  });

  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    loop: true,
    infinite: false,
    fade: true,
    asNavFor: ".slider-nav",
  });
  $(".slider-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: ".slider-for",
    focusOnSelect: true,
    loop: true,
    infinite: true,
    draggable: true,
    swipeToSlide: true,
    verticalSwiping: true,
    responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 0,
      settings: {
        slidesToShow: 1
      }
    }
  ]
  });

  $(".productSlider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      loop: false,
      fade: true,
    });
  });

  } catch(e) { console.error(e); }
})();
})();
